import { SchemaOf, boolean, number, object, string } from 'yup';

import { isValidUrl } from '@@/form-components/validate-url';

import { Values } from './types';

export function validation(): SchemaOf<Values> {
  return object({
    edgeAgentCheckinInterval: number().required(),
    loginBannerEnabled: boolean().default(false),
    loginBanner: string()
      .default('')
      .when('loginBannerEnabled', {
        is: true,
        then: (schema) =>
          schema.required('Login banner is required when enabled'),
      }),
    logoEnabled: boolean().default(false),
    logo: string()
      .default('')
      .when('logoEnabled', {
        is: true,
        then: (schema) =>
          schema
            .required('Logo url is required when enabled')
            .test('valid-url', 'Must be a valid URL', (value) =>
              isValidUrl(value)
            ),
      }),
    snapshotInterval: string().required('Snapshot interval is required'),
    templatesUrl: string()
      .default('')
      .test(
        'valid-url',
        'Must be a valid URL',
        (value) => !value || isValidUrl(value)
      ),
    autoPatchEnabled: boolean().default(false),
    autoPatchCron: string().default(''),
    customRegistryEnabled: boolean().default(false).optional(),
    registryId: number()
      .optional()
      .when('customRegistryEnabled', {
        is: true,
        then: (schema) =>
          schema
            .required('Registry is required')
            .test(
              'not-zero',
              'Registry cannot be Docker Hub (0) when using a custom registry',
              (value) => value !== 0
            ),
      }),
    portainerRepository: string()
      .optional()
      .when('customRegistryEnabled', {
        is: true,
        then: (schema) => schema.required('Portainer repository is required'),
      }),
    updaterRepository: string()
      .optional()
      .when('customRegistryEnabled', {
        is: true,
        then: (schema) => schema.required('Updater repository is required'),
      }),
  });
}
